//是否是第一条记录
export function isFirstHistory(){ 
    	
    var flag = false;
    var length = window.history.length;
    var currentURL = window.location.href;
    var firstURL = sessionStorage.getItem("fisrtHistoryURL");
    
    if (firstURL && _compareURL(firstURL, currentURL)) {
        return true;
    }
    var isIE = false;
    var isOpera = false;
    var isSafari = false
    var isFireFox = false
    var isChrome = false
    var userAgent = navigator.userAgent; 
    var isOpera = userAgent.indexOf("Opera") > -1;
    if (isOpera) {//判断是否Opera浏览器
        isOpera = true
        console.log('是 Opera 浏览器')
    }; 
    if (userAgent.indexOf("Firefox") > -1) {//判断是否Firefox浏览器
        isFireFox = true
        console.log('是 FireFox 浏览器')
    } 
    if (userAgent.indexOf("Chrome") > -1){//判断是否Chrome浏览器
        isChrome = true
        console.log('是 Chrome 浏览器')
    }
    if (!isChrome && userAgent.indexOf("Safari") > -1) {//判断是否Safari浏览器
        isSafari = true
        console.log('是 SaFari 浏览器')
    } 
    if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {//判断是否IE浏览器
        isIE = true
        console.log('是 IE 浏览器')
    };
    //IE,Opera从0开始，Firefox、Chrome和Safari从1开始。        
    if (isIE && !isOpera) {
        if (length == 1) {
            sessionStorage.setItem("fisrtHistoryURL", currentURL)
            flag = true;
        }
    } else if (isSafari || isFireFox || isChrome || isOpera) {
        if (length == 2) {
            sessionStorage.setItem("fisrtHistoryURL", currentURL)
            flag = true;
        }
    }

    return flag;
}

export function _compareURL (e, t) {  
    var n = e.indexOf("?") > -1 ? e.match(/(\S*)(\:\/\/)(\S*)(?=\?)/) : e.match(/(\S*)(\:\/\/)(\S*)/)
      , i = t.indexOf("?") > -1 ? t.match(/(\S*)(\:\/\/)(\S*)(?=\?)/) : t.match(/(\S*)(\:\/\/)(\S*)/);
    if (n && i) {
        var o = n[3]
          , s = i[3];
        return o = "/" == o[o.length - 1] ? o.slice(0, -1) : o,
        s = "/" == s[s.length - 1] ? s.slice(0, -1) : s,
        o == s ? !0 : !1
    }
    return !1
}

export default {
    isFirstHistory
}


// WEBPACK FOOTER //
// ./src/lib/isFirstPage.js